"use strict";

// Class definition
var KTChartsWidget37 = (function () {
  // Private methods
  var initChart = function (chartSelector) {
    var element = document.querySelector(chartSelector);

    if (!element) {
      return;
    }

    var height = parseInt(KTUtil.css(element, "height"));
    var newList = personnelTurnoverList.map((d) => (Math.floor((d / (Math.max(...personnelTurnoverList) * 1.2)) * 100)));
    var options = {
      series: newList,
      chart: {
        height: height,
        type: "radialBar",
      },
      stroke: {
        lineCap: "round",
      },
      plotOptions: {
        bar: {
          borderRaadius: 30,
        },
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: "30%",
            background: "transparent",
            image: undefined,
          },
          dataLabels: {
            show: true,
            name: {
              show: false,
              fontSize: '12px',
              color: '#ff0000'
            },
            value: {
              show: false,
            },
          },
          barLabels: {
            enabled: true,
            name: {
                show: false,
              },
            enabled: true,
            useSeriesColors: true,
            margin: 20,
            fontSize: "12px",
            formatter: function (seriesName, opts) {
              return (
                seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + '%'
              );
            },
          },
        },
      },
      colors: ["#009ef7", "#ffc700", "#50cd89"],
      labels: ["Binek", "Disk", "Balata"],

    };

    var chart = new ApexCharts(element, options);
    chart.render();
  };

  // Public methods
  return {
    init: function () {
      initChart("#kt_custom_radial_widget");
    },
  };
})();

// Webpack support
if (typeof module !== "undefined") {
  module.exports = KTChartsWidget37;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTChartsWidget37.init();
});
